import { palette } from 'main/ui'
import { darken, saturate } from 'polished'

const DARKEN = 0.0490196078
const SATURATE = 0.0087390762

export default darken(DARKEN, saturate(SATURATE, palette.rose2))
